/**
 * TB 工程種類大分類 + 各分類的可用工項。
 * 編輯這個檔案就會直接改動 UI 顯示的列順序與每列可選工項。
 */
export interface EngineeringGroup {
  name: string;
  items: string[];
}

export const ENGINEERING_GROUPS: EngineeringGroup[] = [
  { name: '拆除工程',           items: ['開工拜拜', '保護', '拆除'] },
  { name: '泥作工程',           items: ['泥作', '防水', '石膏磚', '輕隔間'] },
  { name: '水電工程',           items: ['水電'] },
  { name: '木作工程',           items: ['木工'] },
  { name: '系統櫃工程(廚具)',   items: ['系統櫃丈量', '系統櫃', '廚具'] },
  { name: '油漆工程',           items: ['油漆', '壁紙'] },
  { name: '空調工程',           items: ['空調'] },
  { name: '地板工程',           items: ['地板', '石材美容'] },
  { name: '玻璃工程',           items: ['玻璃', '淋浴門', '貼膜'] },
  { name: '清潔工程',           items: ['清潔', '粗清', '細清'] },
  { name: '設備工程',           items: ['設備安裝', '選材'] },
  { name: '鐵件(鋁門窗)工程',   items: ['鐵工', '鋁窗', '鋁框門', '大門'] },
  { name: '其他工程與驗收',     items: ['驗收', '內部驗收', '收款', '簽約', '停工'] },
];

/** 跨工種共用的工項 — 每一列都會出現。 */
export const COMMON_ITEMS: string[] = ['收尾'];

export const GROUP_NAMES: string[] = ENGINEERING_GROUPS.map(g => g.name);

export function itemsForGroup(group: string): string[] {
  const specific = ENGINEERING_GROUPS.find(g => g.name === group)?.items ?? [];
  const merged = [...specific];
  for (const c of COMMON_ITEMS) if (!merged.includes(c)) merged.push(c);
  return merged;
}

/** 舊版分類名稱（從 API 公式區拿到的）→ 新版大分類名稱 的遷移映射。 */
export const LEGACY_GROUP_MIGRATION: Record<string, string> = {
  '木工':     '木作工程',
  '拆除':     '拆除工程',
  '泥作':     '泥作工程',
  '水電':     '水電工程',
  '油漆':     '油漆工程',
  '玻璃':     '玻璃工程',
  '鐵':       '鐵件(鋁門窗)工程',
  '清潔':     '清潔工程',
  '系統櫃':   '系統櫃工程(廚具)',
  '設備':     '設備工程',
  '鋁窗':     '鐵件(鋁門窗)工程',
  '其他':     '其他工程與驗收',
  '簽約':     '其他工程與驗收',
  '收款':     '其他工程與驗收',
};
